import { CampaignChannels } from '@/interfaces';

interface markWaterPosition {
	width: number;
	marginX: number;
	marginY: number;
}

export async function addWaterMark(
	file: File,
	channel: CampaignChannels
): Promise<File> {
	if (typeof window === 'undefined') throw new Error('Only client supported');
	const watermark = (await import('watermarkjs')).default;
	const logoUrl = '/img/common/watermark.png';
	const baseUrl = URL.createObjectURL(file);

	const values = waterMarkByChannel[channel];
	if (!values) throw new Error('Invalid Channel');

	const { width, marginX, marginY } = values;

	try {
		const blob: Blob = await watermark([baseUrl, logoUrl]).blob(
			(base: any, logo: any) => {
				const ctx = base.getContext('2d')!;
				ctx.save();
				ctx.globalAlpha = 1;

				const BW = base.width;
				const BH = base.height;
				const LW = logo.width;
				const LH = logo.height;

				const targetW = Math.round(BW * width);
				const scale = targetW / LW;
				const targetH = Math.round(LH * scale);

				const x = Math.round(BW * marginX);
				const y = Math.round(BH - targetH - BH * marginY);

				// (Opcional) clamp por seguridad
				const clampedX = Math.max(0, Math.min(x, BW - targetW));
				const clampedY = Math.max(0, Math.min(y, BH - targetH));

				// dibuja logo escalado
				ctx.drawImage(logo, clampedX, clampedY, targetW, targetH);
				ctx.restore();
				return base; // <- requerido por watermarkjs
			}
		);

		const ext = blob.type?.split('/')[1] || 'png';
		const name = file.name.replace(/\.\w+$/, '') || 'image';
		return new File([blob], `${name}-wm.${ext}`, {
			type: blob.type || 'image/png',
		});
	} finally {
		URL.revokeObjectURL(baseUrl);
	}
}

export const waterMarkByChannel: Partial<
	Record<CampaignChannels, markWaterPosition>
> = {
	FACEBOOK: {
		width: 0.5,
		marginX: 0.03,
		marginY: 0.07,
	},
	FACEBOOK_ADS: {
		width: 0.5,
		marginX: 0.03,
		marginY: 0.07,
	},
	INSTAGRAM: {
		width: 0.6,
		marginX: 0.03,
		marginY: 0.05,
	},
	INSTAGRAM_ADS: {
		width: 0.6,
		marginX: 0.03,
		marginY: 0.05,
	},
	GOOGLE_ADS: {
		width: 0.5,
		marginX: 0.18,
		marginY: 0.2,
	},
	GOOGLE_SEARCH: {
		width: 0.5,
		marginX: 0.18,
		marginY: 0.2,
	},
};
